// @flow

import { phoneInputCss } from '../../../css/phoneInput';

const confirmTopupPurchaseDialogStyles = {
  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    margin: theme.spacing(1)
  }),
  dialogHeader: (theme) => ({
    margin: `${theme.spacing(1)} ${theme.spacing(1)} 0px ${theme.spacing(1)}`,
    padding: `${theme.spacing(2)} ${theme.spacing(3)} 0px ${theme.spacing(3)}`
  }),
  grow: (theme) => ({
    flexGrow: 1
  }),
  itemHeader: (theme) => ({
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    fontWeight: 600
  }),
  itemList: (theme) => ({
    '& p': {
      fontSize: '1rem',
      color: 'hsl(0,0%,80%)'
    }
  }),
  itemRow: (theme) => ({
    display: 'flex'
  }),
  itemDesc: (theme) => ({
    fontSize: '1rem',
    flexGrow: 1
  }),
  itemPrice: (theme) => ({
    fontSize: '1.2rem',
    color: theme.palette.primary.main,
    fontWeight: 600
  }),
  captionText: (theme) => ({
    fontSize: '1rem',
    color: 'hsl(0,0%,50%)'
  }),
  ccCaptionText: (theme) => ({
    marginTop: theme.spacing(2),
    fontSize: '1rem',
    color: 'hsl(0,0%,50%)'
  })
};

export default confirmTopupPurchaseDialogStyles;
